import { useCallback, useRef, useState } from 'react';

export const useIsTruncated = <T extends HTMLElement>() => {
  const ref = useRef<T | null>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const checkTruncation = useCallback(() => {
    if (ref.current) {
      setIsTruncated(ref.current.scrollWidth > ref.current.clientWidth);
    }
  }, []);

  return { ref, isTruncated, checkTruncation };
};
